export enum LimaShopID {
  undefined = -1,
  Familjeapoteket = 1,
  Vitaminvaruhuset = 2,
  HappyYachting = 3,
  Babyland = 4,
  Apotea = 6,
  BabylandFi = 7,
  Delitea = 8,
  WidForss = 9,
  StorOchLiten = 10,
  Lekia = 11,
  LitenLeker = 12,
  SmartaSaker = 13,
  WidforssNo = 14,
  LekiaNo = 15,
  HappyYachtingNo = 16,
  BabylandNo = 17,
  SmartaSakerNo = 18,
  SmartaSakerCom = 19,
  Retkitukku = 20,
  Koiravaruste = 21,
  TestButik = 100,
}
